//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"AllowMirror",1,0],[0,"Clearance",1,0],[0,"Format",0,0],[0,"Include",1,0],[0,"IsValid",0,0],[0,"Material",0,0],[0,"Name",0,0],[0,"Priority",1,0],[0,"Quantity",1,0],[0,"Rotation",1,0],[0,"RotationOffset",1,0],[0,"RotationTolerance",1,0],[0,"Thickness",0,0]],[[[],"Dispose",{},0,0]],[]];
SPLM.NestingPart = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.NestingPart";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.NestingPart.Rotations = Object.freeze({
    "Free" : "Free", "None" : "None", "Degrees90" : "Degrees90", "Degrees180" : "Degrees180"});

SPLM.NestingPart.Priorities = Object.freeze({
    "Lowest" : "Lowest", "Low" : "Low", "Normal" : "Normal", "High" : "High", "Highest" : "Highest"});

SPLM.NestingPart.Formats = Object.freeze({
    "Prt" : "Prt", "Dxf" : "Dxf"});

export default SPLM;